module.exports = __webpack_public_path__ + "img/7_11.3502d73e.png";